
export function numberToCursor(num: number) {
  return btoa(`${num}`);
}

export function cursorToNumber(cursor: string) {
  return parseInt(atob(cursor), 10);
}

export function cursorSubtract(cursor: string, num: number) {
  return numberToCursor((cursorToNumber(cursor) - num));
}

export function cursorAdd(cursor: string, num: number) {
  return numberToCursor((cursorToNumber(cursor) + num));
}
